import { render, staticRenderFns } from "./recordSetting.vue?vue&type=template&id=6f2c76e9&scoped=true"
import script from "./recordSetting.vue?vue&type=script&lang=js"
export * from "./recordSetting.vue?vue&type=script&lang=js"
import style0 from "./recordSetting.vue?vue&type=style&index=0&id=6f2c76e9&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f2c76e9",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/Test-五域创客/jh-5eck-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6f2c76e9')) {
      api.createRecord('6f2c76e9', component.options)
    } else {
      api.reload('6f2c76e9', component.options)
    }
    module.hot.accept("./recordSetting.vue?vue&type=template&id=6f2c76e9&scoped=true", function () {
      api.rerender('6f2c76e9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/customerBox/recordSetting.vue"
export default component.exports